<template>
    <div class="title-block" :class="{ 'white-space': isSticky }">
        <div class="normal-title row" :class="colorStyle">
            <div class="col-2">
                <router-link to="/">
                    <img src="@/assets/img/logo/RootiCare_logo.png" style="width: 180px;" class="title-img">
                </router-link>
            </div>

            <div class="col col-xl-8 col-xxl-9 menu-block">
                <ul class="element-menu">
                    <li class="col" @mouseover="isAboutUs = true" @mouseleave="isAboutUs = false">
                        <div class="nav-item">
                            <span>Company</span>
                        </div>
                        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                            <ul class="dropdown-menu" v-show="isAboutUs" style="margin-left: 15px;">
                                <li>
                                    <router-link to="/about-us" class="dropdown-item">About Us</router-link>
                                </li>
                                <li>
                                    <router-link to="/" class="dropdown-item">Why Us</router-link>
                                </li>
                            </ul>
                        </transition>
                    </li>
                    <li class="col" @mouseover="isService = true" @mouseleave="isService = false">
                        <div class="nav-item">
                            <span>Service</span>
                        </div>
                        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                            <ul class="dropdown-menu" v-show="isService">
                                <li>
                                    <router-link to="/rooti-care" class="dropdown-item">RootiCare</router-link>
                                </li>
                                <li>
                                    <router-link to="/rooti-rx" class="dropdown-item">Rooti Rx</router-link>
                                </li>
                            </ul>
                        </transition>
                    </li>
                    <li class="col" @mouseover="isTechnology = true" @mouseleave="isTechnology = false">
                        <div class="nav-item">
                            <span>Technology</span>
                        </div>
                        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                            <ul class="dropdown-menu" v-show="isTechnology" style="margin-left: 18px;">
                                <li>
                                    <router-link to="/how-work" class="dropdown-item">How it works</router-link>
                                </li>
                                <li>
                                    <router-link to="/electrocardiogram" class="dropdown-item">
                                        Electrocardiogram (ECG)
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/sleep-apnea" class="dropdown-item">
                                        Sleep Apnea
                                    </router-link>
                                </li>
                            </ul>
                        </transition>

                    </li>
                    <li class="col" @mouseover="isSecurity = true" @mouseleave="isSecurity = false">
                        <div class="nav-item">
                            <span>Security</span>
                        </div>
                        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                            <ul class="dropdown-menu" v-show="isSecurity" style="margin-left: 15px;">
                                <li>
                                    <router-link to="/security" class="dropdown-item">Security</router-link>
                                </li>
                            </ul>
                        </transition>

                    </li>
                    <li class="col" @mouseover="isProjects = true" @mouseleave="isProjects = false">
                        <div class="nav-item">
                            <span>Contribution</span>
                        </div>
                        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                            <ul class="dropdown-menu" v-show="isProjects" style="margin-left: 15px;">
                                <li>
                                    <router-link to="/rooti-kiosk" class="dropdown-item">Rooti Kiosk</router-link>
                                </li>
                            </ul>
                        </transition>

                    </li>
                    <li class="col" @mouseover="isResources = true" @mouseleave="isResources = false">
                        <div class="nav-item">
                            <span>Resources</span>
                        </div>
                        <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                            <ul class="dropdown-menu" v-show="isResources" style="margin-left: 15px;">
                                <li>
                                    <router-link to="/faq" class="dropdown-item">FAQ</router-link>
                                </li>
                                <li>
                                    <router-link to="/medical-papers" class="dropdown-item">Medical papers</router-link>
                                </li>
                                <li>
                                    <div class="dropdown-item-group">
                                        Publications
                                        <ul class="item-ul">
                                            <li>
                                                <router-link to="/publications/ecg" class="dropdown-subitem" style="margin-bottom: 4px;">
                                                    ECG analysis</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/publications/hrv" class="dropdown-subitem" style="margin-bottom: 4px;">
                                                    HRV</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/publications/sleep-apnea" class="dropdown-subitem">
                                                    Sleep apnea</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </transition>

                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isSticky: false,
            isAboutUs: false,
            isService: false,
            isTechnology: false,
            isSecurity: false,
            isForPatients: false,
            isProjects: false,
            isResources: false,
        }
    },
    props: {
        colorStyle: String,
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            let scroll = window.scrollY;
            if (scroll >= 200) {
                this.isSticky = true;
            } else {
                this.isSticky = false;
            }
        },
        beforeEnter(el) {
            el.style.opacity = 0;
            el.style.transform = 'translateY(20px)';
        },
        enter(el, done) {
            el.offsetHeight;
            el.style.transition = 'opacity 0.5s ease, transform 0.3s ease';
            el.style.opacity = 1;
            el.style.transform = 'translateY(0)';
            done();
        },
        leave(el, done) {
            done();
        }
    },
}
</script>

<style lang="scss">
.title-block {
    width: 100%;
    min-width: 1800px;
    max-width: 2048px;
    position: fixed;
    z-index: 99;
}

.normal-title {
    width: 100%;
    display: flex;
    padding: 12px 0 10px 230px;

    .menu-block {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .element-menu {
        background-color: transparent;
        width: 850px;
        text-align: center;
        display: flex;

        .dropdown-item {
            color: #595959;
            font-size: 14px;
            padding: 6px 5px 5px 30px;

            &:hover {
                color: #3498db;
                background-color: transparent;
            }
        }

        .dropdown-item:after {
            content: "";
            width: 7px;
            height: 7px;
            background-color: #595959;
            position: absolute;
            left: 13px;
            transform: translateY(72%);
            transition: transform 0.5s ease;
        }

        .dropdown-item:hover:after {
            transform: translateY(72%) rotate(45deg);
            background-color: #3498db;
        }

        .dropdown-item-group {
            color: #595959;
            font-size: 14px;
            padding: 6px 5px 5px 30px;

            &:hover {
                color: #3498db;
                background-color: transparent;
            }

            .item-ul{
                padding-left: 10%;
                margin-top: 5px;
            }

            .dropdown-subitem {
                color: #595959;
                font-size: 14px;

                &:hover {
                    color: #3498db;
                    background-color: transparent;
                }
            }

            .dropdown-subitem:after {
                content: "";
                display: block;
                height: 1px;
                width: 0;
                background-color: #3498db;
                position: absolute;
                transform: translateY(-4px);
                transition: width 0.5s ease;
            }

            .dropdown-subitem:hover:after {
                width: 67%;
            }
        }


        .dropdown-item-group:after {
            content: "";
            width: 7px;
            height: 7px;
            background-color: #595959;
            position: absolute;
            left: 13px;
            transform: translateY(-92px);
            transition: transform 0.5s ease;
        }

        .dropdown-item-group:hover:after {
            transform: translateY(-92px) rotate(45deg);
            background-color: #3498db;
        }

        .dropdown-menu {
            background-color: rgba(246, 247, 249, 0.9);
            display: block;
            min-width: 140px;
            z-index: 99;
            border: 0;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }
    }

    @media (max-width: 1535px) {
        padding: 12px 0 10px 130px;
    }

    @media screen and (max-width: 1280px) {
        height: 80px;
        width: 1280px;
        padding: 12px 0 10px 0px;

        .title-img {
            display: block;
            padding: 5px 0 0 20px;
        }

        .menu-block {
            left: 53%;
            transform: translateX(-50%);
            position: fixed;

            .element-menu {
                background-color: transparent;
                width: 680px;
                padding: 20px;
                text-align: center;
                display: flex;
            }
        }

    }

    @media screen and (max-width: 769px) {}
}

.white-space {
    animation: fadeInDown .95s ease-in-out 0s 1 normal none running;
    z-index: 999;
    transition: all .3s cubic-bezier(.645, .045, .355, 1);
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, .1);
    background-color: rgba(246, 247, 249, 0.9);

    @media screen and (max-width: 1280px) {
        animation: none;
    }
}

.black-style {
    .nav-item {
        color: #666666;
    }
}

.white-style {
    .nav-item {
        color: white;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    }
}
</style>